import { message } from 'antd';

const MESSAGE_KEY = 'reorder-requires-custom-sort';

export function showReorderRequiresCustomSortHint() {
  message.error({
    key: MESSAGE_KEY,
    content: 'You can only reorder when Sort is set to Custom.',
    duration: 3
  });
}
